(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/index.js');
"use strict";


const OddsetRouter = svs.oddset_kambi.OddsetRouter;
const MaintenanceContextProvider = svs.oddset_kambi.components.maintenance_context.MaintenanceContextProvider;
const BetsContextProvider = svs.oddset_kambi.components.bets_context.BetsContextProvider;
ReactDOM.render(React.createElement(BetsContextProvider, null, React.createElement(MaintenanceContextProvider, null, React.createElement(OddsetRouter, null))), document.getElementById('oddset-container'));

 })(window);